import React from 'react'
import Navigation from '../components/header/Navigation';
import SoftwareDeveloperBody from '../components/body/SoftwareDeveloperBody';

const SoftwareDeveloper = () => {
    return (
        <React.Fragment>
            <Navigation />
            <SoftwareDeveloperBody />
        </React.Fragment>
    )
};

export default SoftwareDeveloper;